import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { isSeries } from '../../../services/content/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import PlaylistAddRemove from '../../PlaylistAddRemove/index'
import { getDetailPageUiElementGQL } from '../utils'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Object} props.ga4EventData - The GA4 details data
 * @returns {JSX.Element} DetailPageV3ActionPlaylist
 */

const DetailPageV3ActionPlaylist = (props) => {
  const {
    detailData = Map(),
    ga4EventData,
    auth,
  } = props

  const contentType = detailData.get('contentType')
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const isAllowed = isSeries({ contentType })
    ? detailData.getIn(['featuredContent', 'featureMedia', 'contentPolicy', 'accessCheck', 'allowed'])
    : detailData.getIn(['featureMedia', 'contentPolicy', 'accessCheck', 'allowed'])

  if (!isAllowed || !isLoggedIn) {
    return null
  }

  return (
    <PlaylistAddRemove
      buttonSvgIcon
      className="detail-page-v3__action-button"
      labelClassName="detail-page-v3__action-label"
      contentId={detailData.get('contentId')}
      contentTitle={detailData.get('title')}
      contentType={contentType}
      ga4EventData={{
        ...ga4EventData,
        media_id: detailData.getIn(['feature', 'id']),
        media_language: detailData.get('languageFullText'),
        is_featured_media: true,
        ui_element: getDetailPageUiElementGQL(contentType, detailData),
      }}
    />
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3ActionPlaylist)
